enum creditScoreQuality {
    EXCELLENT = 'EXCELLENT',
    GOOD = 'GOOD',
    FAIR = 'FAIR',
    POOR = 'POOR',
    UNKNOWN = 'UNKNOWN'
}

export { creditScoreQuality };
